import axios from 'axios';
import { normalize } from 'normalizr';
import * as schema from './schema';

// Configure Axios for our application
axios.interceptors.request.use((config) => {
  const newConf = config;
  // Default to JSON and nothing else!
  newConf.headers['Content-Type'] = 'application/json';
  newConf.headers.Accept = 'application/json';
  newConf.responseType = 'json';
  return config;
});

const normalizeUser = (response) => normalize(response.data, {user: schema.user, meta: {categories:[schema.category]}, claim_questions: [schema.claim_question]});

const normalizeItem = (response) => normalize(response.data, {item: schema.item});

const normalizeItems = (response) => normalize(response.data, {items: [schema.item]});


let domain = ''
let protocol = ''

if (process.env.NODE_ENV === 'development'){
  domain = 'lvh.me:3000'
  protocol = 'http'
}


if (process.env.REACT_APP_ENV === 'staging'){
  domain = 'staging.crowdfind.com'
  protocol = 'https'
}


if (process.env.REACT_APP_ENV === 'production'){
  domain = 'v2.crowdfind.com'
  protocol = 'https'
}

const ApiService = axios.create({
  baseURL: `${protocol}://${domain}/api/v1`,
  timeout: 5000
});

export const updateCurrentUser = (props) =>
  ApiService.post(`/users`, {user: props}).then(normalizeUser);

export const loginCurrentUser = (props) =>
  ApiService.post(`/sessions`, {session: props}).then(normalizeUser);

export const submitSnap = (props) =>
  axios.post(`${protocol}://${props.account_subdomain}.${domain}/api/v1/${props.venue_permalink}/items`, {venue_permalink: props.venue_permalink, api_token: props.api_token, item: props}).then(normalizeItem);

export const getItems = (props) =>
  axios.get(`${protocol}://${props.account_subdomain}.${domain}/api/v1/${props.venue_permalink}/snapit-items`, {params: {venue_permalink: props.venue_permalink, api_token: props.api_token}}).then(normalizeItems);

export const syncItemProps = (api_token,venue_permalink,account_subdomain,item_id,props) =>
  axios.patch(`${protocol}://${account_subdomain}.${domain}/api/v1/${venue_permalink}/items/${item_id}`, {venue_permalink, api_token, item: props}).then(normalizeItem);

export const deleteItem = (api_token,venue_permalink,account_subdomain,item_id) =>
  axios.delete(`${protocol}://${account_subdomain}.${domain}/api/v1/${venue_permalink}/items/${item_id}`, {params: {venue_permalink, api_token}}).then(normalizeItem);




// WEBPACK FOOTER //
// ./src/snapit_app/api.js